import React, { useState } from 'react'
import { useTypewriter } from 'react-simple-typewriter'

const Type = (props) => {

    props.setDone(false)
    const [text] = useTypewriter({
        words: [props.text],
        typeSpeed: 10,
        loop: 1,
        onType: () => {
            window.scrollTo(0, document.body.scrollHeight);
            props.setDone(false);
        },
        onLoopDone: () => {
            // console.log(`done `);
            window.scrollTo(0, document.body.scrollHeight);
            props.setDone(true); // This will change the parent's state
        }
    })

    return (
        <>
            {text}
        </>
    )
}

export default Type;
